import { EntityType } from '@/plugins/cad/module/CADModule/model/common/constant'
import type { IPoint } from '@/plugins/cad/module/CADModule/model/common/interface'
import { BaseEntity } from './BaseEntity'

/**
 * 多行文字实体。
 */
export class MTextEntity extends BaseEntity {
  /** 文字锚点位置 */
  position!: IPoint
  /** 文字内容 */
  contents!: string
  /** 文字高度，单位毫米 */
  textHeight: number = 2.5
  /** 文字旋转角度，单位弧度 */
  rotation = 0
  /** 文字框宽度，单位米 */
  rectWidth?: number | undefined
  /** 文字框初始高度，单位米 */
  rectHeight?: number | undefined
  /** 锚点-对齐方式，默认为左上（1） */
  attachment = 1

  protected readonly serializeKeys: string[] = [
    'position',
    'contents',
    'textHeight',
    'rotation',
    'rectWidth',
    'rectHeight',
    'attachment',
  ]

  constructor(data: Partial<MTextEntity>) {
    super(EntityType.MText)
    Object.assign(this, data)
  }
}
